import styled from 'styled-components'
import {media} from '../../utils'

export const TestingModeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: black;  
  height: 24px;
  margin: 0 auto;
  padding: 0 35px;
  overflow: hidden;
`

export const DebugInfo = styled.div `
  p,
  i {
    display: inline;
    color: green;
    font-size: 13px;
    font-weight: 300;    
    letter-spacing: 1.5px;
  }

  i {
    margin-left: 15px;
  }
  span {
    color: white;
  }
  
  small {
    font-size: 50%;
    display: block;
    margin-top: 12px;
  }
  
  ${media.largePhone` 
   p, i, span{
    display: none;
   }
   `} 
`

export const Options = styled.div`
p, i {
    display: inline;
    color: white;
    font-size: 13px;
    font-weight: 300;    
    letter-spacing: 1.5px;
  }
  span {
    color: green;
  }
  a {
    cursor: pointer;
  }
`

export const TestingLogo = styled.div`
p,
  i {
    display: inline;
    color: white;
    font-size: 13px;
    font-weight: 300;    
    letter-spacing: 1.5px;
  }
  
  img {
    max-width: 24px;
  }
`


// WEBPACK FOOTER //
// ./src/components/layout/TopTestingNavigationStyle.js